import type { PropsWithChildren } from 'react';
import {
  SearchTableScopeProvider as Provider,
  useSearchTableScopeFromRoute,
} from './context';

export function SearchTableScopeRouteProvider({ children }: PropsWithChildren) {
  const scope = useSearchTableScopeFromRoute();
  return <Provider value={scope}>{children}</Provider>;
}
